//@flow
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Modal from '../../../../../../elements/Modal/Modal';

import style from './ErrorLinkModal.scss';
import buttonStyle from '../../../../../../assets/styles/button.scss';

export type ErrorType = 'ebayAuction' | 'notCartUrlFormat' | 'amazonSpain';

type Props = {
  isOpen?: boolean;
  handleClose: () => void;
  error?: ErrorType;
};

export default function ErrorLinkModal(props: Props) {
  const { isOpen, handleClose, error } = props;

  const getContentText = (error: ErrorType) => {
    if (error === 'ebayAuction') {
      return (
        <div className={style.textContent}>
          <span>
            Por el momento, no aceptamos pedidos que sean de subastas (Auction)
            de eBay. Puedes realizar tu pedido de eBay siempre y cuando el
            porducto esté disponible para compra inmediate (Buy it Now).
            Contactácnos si requieres más información.
          </span>
        </div>
      );
    } else if (error === 'notCartUrlFormat') {
      return (
        <div className={style.textContent}>
          <span>
            Cuando tu agregas productos a tu carrito en alguna tienda, estos se
            guardan en tu sesión de la tienda, mas no en el link; por lo que
            cuando otra persona abra ese link, visualizará el carrito vacío.
            Debes usar el link del producto antes de agregarlo al carrito en la
            tienda. Recuerda que para hacer pedidosen Qempo de hasta 5
            productos, debes colocarlos uno por uno e ir agergándolos al carrito
            en Qempo.
          </span>
        </div>
      );
    } else if (error === 'amazonSpain'){
      return (
        <div className={style.textContent}>
          <span>
            Con respecto a Amazon, por el momento no aceptamos pedidos de la
            tienda de España, únicamente de la tienda de USA. Debes buscar el
            producto que deseas en Amazon USA:
            <br />
            <a href='https://www.amazon.com' target="_blank">www.amazon.com</a>
          </span>
        </div>
      );
    }
  };

  const getTitle = (error: ErrorType) => {
    if (error === 'ebayAuction') {
      return <p className={style.title}>No aceptamos pedidos de subastas</p>;
    } else if (error === 'notCartUrlFormat') {
      return (
        <p className={style.title}>
          El link que coloques no debe ser del carrito de compras
        </p>
      );
    } else if (error === 'amazonSpain'){
      return (
        <p className={style.title}>No aceptamos pedidos de Amazon España</p>
      );
    }
  };

  return (
    <Modal
      key='ErrorLinkModal'
      open={isOpen}
      width={450}
      height={350}
      handleClose={() => handleClose()}
    >
      <div className={style.topWrap}>
        <div className={style.textWrap}>{error && getTitle(error)}</div>
      </div>
      <div className={style.contentWrap}>
        {error && getContentText(error)}
        <div className={classNames(buttonStyle.btn, style.buttonWrap)}>
          <button onClick={() => handleClose()}>Continuar</button>
        </div>
      </div>
    </Modal>
  );
}

ErrorLinkModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  error: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/ErrorLinkModal/ErrorLinkModal.jsx